import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Layout } from '../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const VerifyEmail = () => {
  useEffect(() => { document.title = 'Verify Email - SIYAK'; }, []);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Missing verification token.');
      return;
    }

    const verify = async () => {
      try {
        const res = await axios.post(`${API_URL}/api/users/verify-email-change`, { token });
        setStatus('success');
        setMessage(res.data.message || 'Email updated successfully. Please log in with your new email.');
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Verification failed. The link may have expired.');
      }
    };
    verify();
  }, [token]);

  return (
    <Layout>
      <div className="min-h-screen bg-navy-50 flex items-center justify-center py-12 px-4">
        <Card className="w-full max-w-md" data-testid="verify-email-card">
          <CardHeader className="text-center">
            <CardTitle className="text-xl">Email Verification</CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            {status === 'verifying' && (
              <div className="flex flex-col items-center gap-3">
                <Loader2 className="h-10 w-10 animate-spin text-navy-600" />
                <p className="text-muted-foreground">Verifying your new email...</p>
              </div>
            )}
            {status === 'success' && (
              <div className="flex flex-col items-center gap-3">
                <CheckCircle className="h-10 w-10 text-green-600" />
                <p className="text-green-700 font-medium">{message}</p>
                <Button onClick={() => navigate('/login')} data-testid="go-to-login-btn">
                  Go to Login
                </Button>
              </div>
            )}
            {status === 'error' && (
              <div className="flex flex-col items-center gap-3">
                <XCircle className="h-10 w-10 text-red-500" />
                <p className="text-red-600 font-medium">{message}</p>
                <Button variant="outline" onClick={() => navigate('/profile')} data-testid="back-to-profile-btn">
                  Back to Profile
                </Button>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};
